<template>
  <popup :close-action="closeAction" class="open-banking-celebration-popup" :buttons="buttons">
    <template v-slot:content>
      <div class="image">
        <lottie-player :src="JSON.stringify(require('@/assets/celebration/turnover.json'))" :autoplay="true" :loop="false"/>
      </div>
      <div class="title">
        כיף שבחרת להשתתף איתנו במהפכת הבנקאות הפתוחה!
      </div>
      <div class="subtitle">
        האפשרות לחיבור ישיר ב{{sourceName}} עדיין בהרצה. אם נתקלת בבעיה, מומלץ לפנות אלינו לקבלת תמיכה.
      </div>
    </template>
  </popup>
</template>

<script>

import BaseUI from 'base-ui';
import Segment from '@/Segment';
import ConsentActionsMixin from '@/base-components/onboarding/openBanking/ConsentActionsMixin';

export default {
  name: 'OpenBankingCelebrationPopup',
  components: {
    Popup: BaseUI.Popup,
  },
  mixins: [ConsentActionsMixin],
  props: {
    source: {
      type: Object,
      required: true,
    },
    action: {
      type: Function,
      required: true,
    },
  },
  created() {
    Segment.trackUserGot('OBKCelebrationPopupShown', { source: this.sourceName });
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    sourceName() {
      return this.source.displayName;
    },
    buttons() {
      return [{
        title: `להמשך החיבור ב${this.sourceName}`,
        action: () => {
          Segment.trackUserGot('OBKCelebrationPopupClicked', { source: this.sourceName });
          this.loading = true;
          this.closeAction();
          this.action();
          this.loading = false;
        },
        size: 'slim',
        loading: this.loading,
      }];
    },
  },
  methods: {
    closeAction() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
@import '~base-ui/src/scss/riseup-colors';

.open-banking-celebration-popup {
  text-align: center;

  .image {
    padding: 20px;
    margin-bottom: 15px;
  }

  .title {
    font-size: 22px;
    font-weight: bold;
    text-align: center;
  }

  .subtitle {
    font-size: 16px;
    text-align: center;
    margin-bottom: 15px;
    line-height: 22px;
  }
}

</style>
